import { CLabel } from '@coreui/react';
import * as React from 'react';
import ReactSpeedometer from "react-d3-speedometer";
import { Utils } from '../../core/utils';
import { ControlModel } from '../../models/index';
import { KComplements } from '../KComplements';

interface IProps {
	Control: ControlModel
}

// Composant de type jauge
export class KControlJauge extends React.Component<IProps> {

	public constructor(props: any) {
		super(props);

		if (this.props.Control.Min == undefined) this.props.Control.Min = 0;
		if (this.props.Control.Max == undefined) this.props.Control.Max = 100;
	}

	//#region rendus

	renderSVG = (valeur: number) => {
		if (!valeur) valeur = 0;
		let max:number = this.props.Control.Max;
		if (valeur > max) max = valeur;

		return (
			<ReactSpeedometer ringWidth={30} width={130} height={90} value={valeur}
				maxSegmentLabels={1}
				minValue={this.props.Control.Min}
				maxValue={max}
				valueTextFontSize="14px"
				paddingHorizontal={0}
				labelFontSize={"11px"}
				segments={this.props.Control.JaugeSegments}
				startColor={this.props.Control.JaugeStartColor}
				endColor={this.props.Control.JaugeEndColor}
			/>
		);
	}

	render() {
		let ctrl = this.props.Control;
		if (!ctrl.Visible) return null;

		let inlineStyle = Utils.decodeInlineStyleFromJson(ctrl.InlineStyle);
		let svg = this.renderSVG(Number(ctrl.Value));

		return (
			<div className={`KControl KControlJauge ${ctrl.Class} `} style={inlineStyle} >
				<CLabel htmlFor={this.props.Control.Key} >{ctrl.Description}</CLabel>
				<div className="KJaugeWrapper"> 
					{svg}
				</div>
				<KComplements Control={ctrl} />
			</div>
		)
	}

	//#endregion 
}